var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSelectAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.036,
    height: 34.036,
    viewBox: "0 0 34.036 34.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.268-93.75a17.026,17.026,0,0,0-12.034,4.984A17.024,17.024,0,0,0,6.25-76.732,17.026,17.026,0,0,0,11.234-64.7a17.024,17.024,0,0,0,12.034,4.984A17.026,17.026,0,0,0,35.3-64.7a17.024,17.024,0,0,0,4.984-12.034A17.026,17.026,0,0,0,35.3-88.766,17.024,17.024,0,0,0,23.268-93.75ZM20.132-69.439l-5.713-7.148,1.9-1.507,4.011,5.008,9.98-9.98,1.726,1.726Z",
    transform: "translate(-6.25 93.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectAll);
export default __webpack_public_path__ + "static/media/icon-select-all.1266c7d4.svg";
export { ForwardRef as ReactComponent };